<template>
  <div>
    <page-header :title="$t('system.text_14')" />
    <page-body>
      <a-form
        :form="form.fc"
        v-bind="formItemLayout">
        <a-form-item :label="$t('system.text_468')">
          <a-select v-decorator="decorators.type">
            <a-select-option v-for="typeObj in options.SERVICE_TYPES" :value="typeObj.key" :key="typeObj.key">{{ typeObj.label }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('system.text_469')" :help="$t('system.text_470')">
          <a-input v-decorator="decorators.url" />
        </a-form-item>
        <a-form-item :label="$t('system.text_471')" :help="$t('system.text_472')">
          <a-input v-decorator="decorators.name" />
        </a-form-item>
        <a-form-item :label="$t('system.text_221')" :help="$t('system.text_473')">
          <a-input-password v-decorator="decorators.pwd" />
        </a-form-item>
      </a-form>
    </page-body>
    <page-footer>
      <div slot="right">
        <a-button type="primary" @click="handleConfirm" :loading="submiting" size="large">{{$t('system.text_120')}}</a-button>
      </div>
    </page-footer>
  </div>
</template>

<script>
import * as R from 'ramda'
import { Base64 } from 'js-base64'
import { SERVICE_TYPES } from './constants'

export default {
  name: 'ThirdPartyIndex',
  data () {
    return {
      loading: false,
      submiting: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        type: [
          'type',
          {
            initialValue: SERVICE_TYPES[0].key,
            rules: [
              {
                required: true,
              },
            ],
          },
        ],
        url: [
          'url',
          {
            rules: [
              {
                required: true,
                transform: val => val && R.trim(val),
              },
              { validator: this.$validate('url') },
            ],
          },
        ],
        name: [
          'name',
          {
            rules: [
              {
                required: true,
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        pwd: [
          'pwd',
          {
            rules: [
              {
                required: true,
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
          xxl: {
            span: 22,
          },
        },
        labelCol: {
          span: 3,
          xxl: {
            span: 2,
          },
        },
      },
      options: {
        SERVICE_TYPES,
      },
    }
  },
  destroyed () {
    this.manager = null
  },
  created () {
    this.manager = new this.$Manager('extra-users', 'v1')
  },
  mounted () {
    this.fetchExtraUsers(SERVICE_TYPES[0].key)
  },
  methods: {
    async handleConfirm () {
      this.submiting = true
      try {
        const values = await this.form.fc.validateFields()
        const { name, pwd, type, url } = values
        const params = {
          user_name: name,
          pwd: Base64.encode(pwd),
          type,
          url,
        }
        await this.manager.create({
          data: params,
        })
        this.$message.success(this.$t('system.text_474'))
      } catch (error) {
        throw error
      } finally {
        this.submiting = false
      }
    },
    fetchExtraUsers (ctype) {
      this.manager.list()
        .then((res) => {
          const dataArr = res.data.data || []
          const data = dataArr.find(item => item.type === ctype)
          const { type, url, user_name } = data
          if (data) {
            this.form.fc.setFieldsValue({
              type,
              url,
              name: user_name,
            })
          }
        })
        .catch((err) => {
          throw err
        })
    },
  },
}
</script>
